import React, { useState } from 'react'
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai'
import axiosConfig from "../../Services/axiosConfig"
import LoginModal from '../Login/Login'
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { addWishlistItem, removeWishlistItem } from '../../redux/wishlistSlice';

function Wishlist({ productData, selectedOption, wishListed, onLoad }) {
  const [loginShow, setLoginShow] = useState(false);
  const dispatch = useDispatch();

  const isLogin = localStorage.getItem("token")
  const userId = localStorage.getItem("userid")
  const handleLoginShow = () => setLoginShow(true)
  async function addToWishlist() {
    if (!isLogin) return handleLoginShow()
    const payload = {
      user: userId,
      varient: productData?.id,
      type: selectedOption === "buy" ? "sale" : "rental"
    }
    try {
      const response = await axiosConfig.post(`/catlog/wishlists/`, payload)
      dispatch(addWishlistItem({
        id: productData?.id,
        type: selectedOption === "buy" ? "sale" : "rental",
        wishlistId: response?.data?.id
      }));
      onLoad && onLoad();
      window.dispatchEvent(new Event("wishlistUpdated"));
      toast.success("product added to wishlist")
    } catch (error) {
      console.log(error)
    }
  }
  async function removeFromWishList() {
    try {
      await axiosConfig.delete(`/catlog/wishlists/${wishListed?.id}/`)
      dispatch(removeWishlistItem(productData?.id || wishListed?.varient || wishListed?.id));
      toast.success("product removed from wishlist")
      window.dispatchEvent(new Event("wishlistUpdated"));
      onLoad && onLoad();
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <div>
      {
        wishListed?.in_wishlist ? <AiFillHeart className='wishlisted-icon' size={18} onClick={removeFromWishList} /> :
          <AiOutlineHeart className='wishlisted-icon' size={18} onClick={addToWishlist} />
      }
      <LoginModal show={loginShow} onHide={() => setLoginShow(false)} />
    </div>
  )
}

export default React.memo(Wishlist)